export default "__VITE_ASSET__4qO9aX2I__"